// extracted by mini-css-extract-plugin
export default {"layoutContainer":"MainLayout_layoutContainer__vTL3B","mainContent":"MainLayout_mainContent__0R7Mf","sidebarCollapsed":"MainLayout_sidebarCollapsed__8eFdv"};